import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ImageMeta } from '@libraries/component-library';
import { FeaturesService } from '@libraries/feature-flags';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { getEligibilityImage } from '../state';

@Injectable()
export class ImageDataResolver implements Resolve<ImageMeta> {
  constructor(private store: Store, private features: FeaturesService) {}

  resolve(): Observable<ImageMeta> {
    return this.store.select(getEligibilityImage).pipe(
      map((image) => ({
        title: 'questions.getApprovedTitle',
        translate: true,
        image,
      })),
      take(1)
    );
  }
}
